import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Elementos de contextualización' }
  },
  {
    path: '/accionProblemica',
    name: 'AP',
    component: () => import(/* webpackChunkName: "accionProblemica" */ '../views/AP.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Acción problémica' }
  },
  {
    path: '/conocimientosPrevios',
    name: 'CP',
    component: () => import(/* webpackChunkName: "conocimientosPrevios" */ '../views/CP.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Act. Conocimientos previos' }
  },
  {
    path: '/Tema1',
    name: 'Tema1',
    component: () => import(/* webpackChunkName: "Tema1" */ '../views/Tema1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 1' }
  },
  {
    path: '/Tema1_1.1',
    name: 'Tema1_1-1',
    component: () => import(/* webpackChunkName: "Tema1_1.1" */ '../views/Tema1_1-1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 1 - 1.1' }
  },
  {
    path: '/Tema1_1.2',
    name: 'Tema1_1-2',
    component: () => import(/* webpackChunkName: "Tema1_1.2" */ '../views/Tema1_1-2.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 1 - 1.2' }
  },
  {
    path: '/Tema2',
    name: 'Tema2',
    component: () => import(/* webpackChunkName: "Tema2" */ '../views/Tema2.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 2' }
  },
  {
    path: '/Tema2_2.1',
    name: 'Tema2_2-1',
    component: () => import(/* webpackChunkName: "Tema2_2.1" */ '../views/Tema2_2-1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 2 - 2.1' }
  },
  {
    path: '/Tema3',
    name: 'Tema3',
    component: () => import(/* webpackChunkName: "Tema3" */ '../views/Tema3.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 3' }
  },
  {
    path: '/Tema3_3.1',
    name: 'Tema3_3-1',
    component: () => import(/* webpackChunkName: "Tema3_3.1" */ '../views/Tema3_3-1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 3 - 3.1' }
  },
  {
    path: '/Tema3_3.2',
    name: 'Tema3_3-2',
    component: () => import(/* webpackChunkName: "Tema3_3.1" */ '../views/Tema3_3-2.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 3 - 3.2' }
  },
  {
    path: '/Tema4',
    name: 'Tema4',
    component: () => import(/* webpackChunkName: "Tema4" */ '../views/Tema4.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 4' }
  },
  {
    path: '/Tema4_4.1',
    name: 'Tema4_4-1',
    component: () => import(/* webpackChunkName: "Tema4_4.1" */ '../views/Tema4_4-1.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Tema 4 - 4.1' }
  },

  {
    path: '/actividadSeguimiento',
    name: 'AS',
    component: () => import(/* webpackChunkName: "autoEvaluacion" */ '../views/AS.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Act. Seguimiento' }
  },
  {
    path: '/autoEvaluacion',
    name: 'AE',
    component: () => import(/* webpackChunkName: "autoEvaluacion" */ '../views/AE.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Act. Autoevaluación' }
  },
  {
    path: '/finUnidad',
    name: 'Fin',
    component: () => import(/* webpackChunkName: "finUnidad" */ '../views/FIN.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Fin de la unidad' }
  },
  {
    path: '/referenciasBibliograficas',
    name: 'REF',
    component: () => import(/* webpackChunkName: "referenciasBibliograficas" */ '../views/REF.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Referencias bibliográficas' }
  },
  {
    path: '/creditos',
    name: 'Creditos',
    component: () => import(/* webpackChunkName: "creditos" */ '../views/CRED.vue'),
    meta: { title: 'Introducción a la Lingüística - Unidad 2 / Créditos' }

  }
  
  
]

const router = new VueRouter({
  routes
})



export default router
